import {Component, Input, OnInit, Output, EventEmitter} from '@angular/core';

@Component({
    selector: 'switch-component',
    templateUrl: './switch.component.html',
    styleUrls: ['./switch.component.scss']
})
export class SwitchComponent implements OnInit {

    @Input() gameMode: string;

    @Output() gameModeChange = new EventEmitter();

    constructor() {
    }

    ngOnInit() {
    }

    click(){
        if(this.gameMode == 'straightOut'){
            this.gameMode = 'doubleOut';
        } else this.gameMode = 'straightOut';

        this.gameModeChange.emit(this.gameMode);

        console.log(this.gameMode);

        // this.gameModeChanges.emit(this.gameMode);
    }





}



// WEBPACK FOOTER //
// ./src/app/components/switch/switch.component.ts